import React from 'react';

const Video = ({ stroke, ...props }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="none"
      d="M2.25 6.03091H14.25C15.0456 6.03091 15.8087 6.34698 16.3713 6.90959C16.9339 7.4722 17.25 8.23526 17.25 9.03091V18.0309C17.25 18.2298 17.171 18.4206 17.0303 18.5612C16.8897 18.7019 16.6989 18.7809 16.5 18.7809H4.5C3.70435 18.7809 2.94129 18.4648 2.37868 17.9022C1.81607 17.3396 1.5 16.5766 1.5 15.7809V6.78091C1.5 6.582 1.57902 6.39124 1.71967 6.25058C1.86032 6.10993 2.05109 6.03091 2.25 6.03091V6.03091Z"
      strokeWidth="1.5"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M17.25 10.9059L22.5 7.90591V16.9059L17.25 13.9059"
      strokeWidth="1.5"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Video;
